module.exports = __webpack_public_path__ + "img/dot_chart.ab25f38f.svg";